export default {
	currentEvent: null
};
